export default "__VITE_ASSET__1656a44f__"